import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "app-background"
};
const _hoisted_2 = {
  class: "container mobile-chat-list"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "chat-list-item"
};
const _hoisted_5 = {
  class: "van-ellipsis"
};
const _hoisted_6 = {
  class: "picker-option"
};
import { ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { showConfirmDialog, showFailToast, showSuccessToast } from "vant";
import { checkSession } from "@/store/cache";
import { router } from "@/router";
import { removeArrayItem, showLoginDialog } from "@/utils/libs";
export default {
  __name: 'ChatList',
  setup(__props) {
    const title = ref("会话列表");
    const chatName = ref("");
    const chats = ref([]);
    const allChats = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const error = ref(false);
    const loginUser = ref(null);
    const isLogin = ref(false);
    const roles = ref([]);
    const models = ref([]);
    const showPicker = ref(false);
    const columns = ref([roles.value, models.value]);
    const showEditChat = ref(false);
    const item = ref({});
    const tmpChatTitle = ref("");
    checkSession().then(user => {
      loginUser.value = user;
      isLogin.value = true;
      // 加载角色列表
      httpGet(`/api/app/list/user`).then(res => {
        if (res.data) {
          const items = res.data;
          for (let i = 0; i < items.length; i++) {
            // console.log(items[i])
            roles.value.push({
              text: items[i].name,
              value: items[i].id,
              icon: items[i].icon,
              helloMsg: items[i].hello_msg
            });
          }
        }
      }).catch(() => {
        showFailToast("加载聊天角色失败");
      });

      // 加载模型
      httpGet('/api/model/list?enable=1').then(res => {
        if (res.data) {
          const items = res.data;
          for (let i = 0; i < items.length; i++) {
            models.value.push({
              text: items[i].name,
              value: items[i].id
            });
          }
        }
      }).catch(e => {
        showFailToast("加载模型失败: " + e.message);
      });
    }).catch(() => {
      loading.value = false;
      finished.value = true;

      // 加载角色列表
      httpGet('/api/app/list/user').then(res => {
        if (res.data) {
          const items = res.data;
          for (let i = 0; i < items.length; i++) {
            // console.log(items[i])
            roles.value.push({
              text: items[i].name,
              value: items[i].id,
              icon: items[i].icon,
              helloMsg: items[i].hello_msg
            });
          }
        }
      }).catch(() => {
        showFailToast("加载聊天角色失败");
      });

      // 加载模型
      httpGet('/api/model/list').then(res => {
        if (res.data) {
          const items = res.data;
          for (let i = 0; i < items.length; i++) {
            models.value.push({
              text: items[i].name,
              value: items[i].id
            });
          }
        }
      }).catch(e => {
        showFailToast("加载模型失败: " + e.message);
      });
    });
    const onLoad = () => {
      checkSession().then(() => {
        httpGet("/chat/list?user_id=" + loginUser.value.id).then(res => {
          if (res.data) {
            chats.value = res.data;
            allChats.value = res.data;
            finished.value = true;
          }
          loading.value = false;
        }).catch(() => {
          error.value = true;
          showFailToast("加载会话列表失败");
        });
      }).catch(() => {});
    };
    const search = () => {
      if (chatName.value === '') {
        chats.value = allChats.value;
        return;
      }
      const items = [];
      for (let i = 0; i < allChats.value.length; i++) {
        if (allChats.value[i].title.toLowerCase().indexOf(chatName.value.toLowerCase()) !== -1) {
          items.push(allChats.value[i]);
        }
      }
      chats.value = items;
    };
    const clearAllChatHistory = () => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      showConfirmDialog({
        title: '操作提示',
        message: '确定要删除所有的会话记录吗？'
      }).then(() => {
        httpGet("/chat/clear").then(() => {
          showSuccessToast('所有聊天记录已清空');
          chats.value = [];
        }).catch(e => {
          showFailToast("操作失败：" + e.message);
        });
      }).catch(() => {
        // on cancel
      });
    };
    const newChat = item => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      showPicker.value = false;
      const options = item.selectedOptions;
      router.push(`/mobile/chat/session?title=新对话&role_id=${options[0].value}&model_id=${options[1].value}`);
    };
    const changeChat = chat => {
      router.push(`/mobile/chat/session?chat_id=${chat.chat_id}`);
    };
    const editChat = row => {
      showEditChat.value = true;
      item.value = row;
      tmpChatTitle.value = row.title;
    };
    const saveTitle = () => {
      httpPost('/api/chat/update', {
        chat_id: item.value.chat_id,
        title: tmpChatTitle.value
      }).then(() => {
        showSuccessToast("操作成功！");
        item.value.title = tmpChatTitle.value;
      }).catch(e => {
        showFailToast("操作失败：" + e.message);
      });
    };
    const removeChat = item => {
      httpGet('/api/chat/remove?chat_id=' + item.chat_id).then(() => {
        chats.value = removeArrayItem(chats.value, item, function (e1, e2) {
          return e1.id === e2.id;
        });
      }).catch(e => {
        showFailToast('操作失败：' + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_cell = _resolveComponent("van-cell");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_swipe_cell = _resolveComponent("van-swipe-cell");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_dialog = _resolveComponent("van-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_nav_bar, {
        title: title.value,
        "left-text": "新建会话",
        onClickLeft: _cache[0] || (_cache[0] = $event => showPicker.value = true),
        "custom-class": "navbar"
      }, {
        right: _withCtx(() => [_createVNode(_component_van_icon, {
          name: "delete-o",
          onClick: clearAllChatHistory
        })]),
        _: 1
      }, 8, ["title"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_search, {
        modelValue: chatName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => chatName.value = $event),
        "input-align": "center",
        placeholder: "请输入会话标题",
        "custom-class": "van-search",
        onInput: search
      }, null, 8, ["modelValue"]), _createVNode(_component_van_list, {
        error: error.value,
        "onUpdate:error": _cache[2] || (_cache[2] = $event => error.value = $event),
        loading: loading.value,
        "onUpdate:loading": _cache[3] || (_cache[3] = $event => loading.value = $event),
        finished: finished.value,
        "error-text": "请求失败，点击重新加载",
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chats.value, item => {
          return _openBlock(), _createBlock(_component_van_swipe_cell, {
            key: item.id
          }, {
            right: _withCtx(() => [_createVNode(_component_van_button, {
              square: "",
              text: "修改",
              type: "primary",
              onClick: $event => editChat(item)
            }, null, 8, ["onClick"]), _createVNode(_component_van_button, {
              square: "",
              text: "删除",
              type: "danger",
              onClick: $event => removeChat(item)
            }, null, 8, ["onClick"])]),
            default: _withCtx(() => [_createVNode(_component_van_cell, {
              onClick: $event => changeChat(item)
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
                src: item.icon,
                round: ""
              }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)])]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["error", "loading", "finished"])])]), _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => showPicker.value = $event),
        position: "bottom",
        class: "popup"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          columns: columns.value,
          title: "选择模型和角色",
          onCancel: _cache[4] || (_cache[4] = $event => showPicker.value = false),
          onConfirm: newChat
        }, {
          option: _withCtx(item => [_createElementVNode("div", _hoisted_6, [item.icon ? (_openBlock(), _createBlock(_component_van_image, {
            key: 0,
            src: item.icon,
            fit: "cover",
            round: ""
          }, null, 8, ["src"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(item.text), 1)])]),
          _: 1
        }, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_dialog, {
        show: showEditChat.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => showEditChat.value = $event),
        title: "修改对话标题",
        "show-cancel-button": "",
        class: "dialog",
        onConfirm: saveTitle
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: tmpChatTitle.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => tmpChatTitle.value = $event),
          label: "",
          placeholder: "请输入对话标题",
          class: "field"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};